module.exports = __webpack_public_path__ + "media/img/souvenirpixels-d9ae160f.jpg";